import { testimonials } from '@/mocks/data';

export default function TestimonialSection() {
  return (
    <section className="w-full px-4 md:px-6 lg:px-10 py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-3">
            用户口碑
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            听听火影粉丝们怎么说
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, index) => (
            <div
              key={index}
              className="bg-background-100 rounded-lg p-6"
            >
              <div className="flex items-center gap-3 mb-4">
                <img
                  src={t.avatar}
                  alt={t.name}
                  className="w-12 h-12 rounded-full object-cover"
                />
                <div>
                  <p className="text-sm font-semibold text-foreground-900">{t.name}</p>
                  <p className="text-xs text-foreground-500">{t.role}</p>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">
                &ldquo;{t.content}&rdquo;
              </p>
              <div className="flex items-center gap-0.5 mt-4">
                {[1, 2, 3, 4, 5].map((star) => (
                  <div key={star} className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-star-fill text-sm text-primary-500"></i>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}